import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import appStoreEnLogo from "@Images/app-store-en.svg";
import appStoreEsLogo from "@Images/app-store-es.svg";
import appStoreFrLogo from "@Images/app-store-fr.svg";
import appStoreItLogo from "@Images/app-store-it.svg";
import googlePlayEnLogo from "@Images/google-play-en.png";
import googlePlayEsLogo from "@Images/google-play-es.png";
import googlePlayFrLogo from "@Images/google-play-fr.png";
import googlePlayItLogo from "@Images/google-play-it.png";
import getUrlAppStoreButton from "@Utils/appStoreUrl";
import "./style.scss";

export interface Props {
  store: "apple" | "google";
}

const AppStoreLink: FunctionComponent<Props> = ({ store }) => {
  const intl = useIntl();
  const appStoreIcons: {
    [key: string]: {
      apple: string;
      google: string;
    };
  } = {
    en: { apple: appStoreEnLogo, google: googlePlayEnLogo },
    es: { apple: appStoreEsLogo, google: googlePlayEsLogo },
    fr: { apple: appStoreFrLogo, google: googlePlayFrLogo },
    it: { apple: appStoreItLogo, google: googlePlayItLogo },
  };

  return (
    <div className="AppStoreLink">
      <a href={getUrlAppStoreButton(store)}>
        {store === "apple" ? (
          <img alt={store} src={appStoreIcons[intl.locale].apple} />
        ) : (
          <img alt={store} src={appStoreIcons[intl.locale].google} />
        )}
      </a>
    </div>
  );
};

export default AppStoreLink;
